import React from 'react';
import styled from 'styled-components';

import COLORS from 'constants/colors';
import ConfirmationOverlay from 'shared/ConfirmationOverlay';

export interface HumiditySaveConfirmationValues {
  humidityGreen: string;
  waterActivity: string;
  humidityDryParchment: string;
}

export interface HumiditySaveConfirmationOverlayProps {
  identifier: string;
  values: HumiditySaveConfirmationValues;
  onConfirmClick: (event: React.MouseEvent) => void;
  onCancelClick: (event: React.MouseEvent) => void;
}

const Lead = styled.p`
  margin-bottom: 1rem;
  font-weight: bold;
`;

// Mismo bloque que StepConfirmationOverlay (analisis fisico): los valores que se van a
// guardar, destacados, para revisarlos antes de finalizar la medicion.
const Values = styled.ul`
  margin: 0 0 1rem;
  border-left: 4px solid ${COLORS.BLUE};
  padding: 0.75rem 1rem;
  background: rgba(0, 0, 0, 0.04);
  list-style: none;

  li {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    margin-bottom: 0.35rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  strong {
    font-variant-numeric: tabular-nums;
  }
`;

// PLA-1012 v2: reemplaza al window.confirm nativo que pedia confirmar el guardado
// permanente de la humedad en /lots, con el overlay del sistema.
function HumiditySaveConfirmationOverlay({
  identifier,
  values,
  onConfirmClick,
  onCancelClick,
}: HumiditySaveConfirmationOverlayProps) {
  const fields = [
    {
      label: I18n.translate('attributes.humidity_green'),
      value: values.humidityGreen,
      suffix: '%',
    },
    { label: I18n.translate('attributes.water_activity'), value: values.waterActivity },
    {
      label: I18n.translate('attributes.humidity_parchment_short'),
      value: values.humidityDryParchment,
      suffix: '%',
    },
  ];

  return (
    <ConfirmationOverlay
      id={`${identifier}_humidity_save_confirmation`}
      title={I18n.translate('humidity_analysis_overlay.save_confirmation.title')}
      titlePrefix={identifier}
      confirmText={I18n.translate('buttons.confirm')}
      cancelText={I18n.translate('buttons.cancel')}
      onConfirmClick={onConfirmClick}
      onCancelClick={onCancelClick}
    >
      <Lead>
        {I18n.translate('humidity_analysis_overlay.permanent_save_confirmation')}
      </Lead>

      <Values>
        {fields.map((field) => (
          <li key={field.label}>
            <span>{field.label}</span>
            <strong>
              {field.value === '' ? '--' : field.value}
              {field.value !== '' && field.suffix ? ` ${field.suffix}` : ''}
            </strong>
          </li>
        ))}
      </Values>
    </ConfirmationOverlay>
  );
}

export default HumiditySaveConfirmationOverlay;
